import template from './monthly-income.jade';

export default angular
  .module('cian.addForm.monthlyIncome', [])
  .directive('cianAfPriceAndDealTermsMonthlyIncome', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller: [
      '$scope',
      'businessService',
      function ($scope, businessService) {
        this.ad.monthlyIncome = this.ad.monthlyIncome || {};
        this.isRequired = businessService.isCommercialBusinessAvailable;

        $scope.$watch(
          () => angular.isObject(this.ad.bargainTerms) && this.ad.bargainTerms.currency,
          currency => {
            if (!currency) {
              return;
            }

            this.ad.monthlyIncome.currency = currency;
          },
        );
      },
    ],
    controllerAs: 'monthlyIncome',
    template,
  })).name;
